export type MentorStatusValues =
  | 'FILLING_FORM'
  | 'TRAINING'
  | 'TRAINING_REGISTERED'
  | 'SIGNING_CHART'
  | 'ACCEPTED'
  | 'AVAILABLE'
  | 'REFUSED'
  | 'MENTORSHIP_ACTIVE';

enum MENTOR_STATUS {
  FILLING_FORM = 'Complète le questionnaire',
  TRAINING = 'En attente de formation',
  TRAINING_REGISTERED = 'Inscrit à la formation',
  SIGNING_CHART = 'En attente de validation de la charte',
  ACCEPTED = 'Mentor accepté',
  AVAILABLE = 'Mentor disponible',
  REFUSED = 'Mentorat refusé',
  MENTORSHIP_ACTIVE = 'Mentorat en cours',
}
export default MENTOR_STATUS;
